<template>
  <flex :spacing="3">
    <flex-col md12 sm24 v-for="(block, index) in blocks" :span="span" :key="index">
      <section-blocks :block="block" :title="title" :tooltip="tooltip" />
    </flex-col>
  </flex>
</template>
<script>
export default {
  name: 'AllSectionBlocks',
  data () {
    return {
      blocks: [
        'ui',
        'content',
        'forms',
        'directives'
      ]
    }
  },
  props: {
    title: {
      type: Boolean
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    span: {
      type: Number,
      default: 12
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/all-section-blocks.vue